module.exports = __webpack_public_path__ + "c_static/img/home_inreview.292eb99.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/home_inreview.png
// module id = Fo6g
// module chunks = 33